import React from "react";

const fileLimit = 200;
import SvgIcon from "../SvgIcon";
import { truncateVideoText } from "../../utils/string-helpers";

const VideoUpload = ({
  videoFile,
  videoUrl,
  videoOriginal,
  handleInputChange,
  cleanVideoField,
  form,
}) => {
  const [isOutOfLimit, setIsOutOfLimit] = React.useState(false);

  const showDisableVideoInputClassUrl = !!videoUrl ? "disable-video-input" : "";

  return (
    <div className="form-row">
      <div className="form-row-item">
        <label
          className={`sub-label ${
            !!videoFile || videoOriginal ? "disable-video-input" : ""
          }`}
        >
          Exercise URL
        </label>
        <input
          className="url-input"
          type="text"
          name="videoUrl"
          placeholder={`${
            !!videoFile || videoOriginal ? "" : "Paste link for YouTube, etc"
          }`}
          value={videoUrl || ""}
          onChange={handleInputChange}
          disabled={!!videoFile || videoOriginal}
          form={form}
        />
      </div>

      <div className="form-row-item">
        <label className={`sub-label ${showDisableVideoInputClassUrl}`}>
          Video upload (max 200MB) {isOutOfLimit && " - File size is too big"}
        </label>
        <label
          className={`video-input${
            videoOriginal || videoFile ? " uploaded" : ""
          } ${showDisableVideoInputClassUrl}`}
        >
          <div>
            <SvgIcon
              src={
                videoOriginal || videoFile
                  ? "/img/new-icons/Video.svg"
                  : "/img/new-icons/upload-file.svg"
              }
              noFilterOnLight={videoOriginal || videoFile ? false : true}
            />{" "}
            {videoOriginal || videoFile
              ? `${
                  truncateVideoText(videoOriginal) ||
                  truncateVideoText(
                    videoFile.split("\\")[videoFile.split("\\").length - 1]
                  )
                }`
              : "Choose File"}
          </div>
          {(videoOriginal || videoFile) && (
            <button
              data-button-type="secondry"
              data-icon-only={true}
              data-icon={true}
              onClick={(e) => {
                e.preventDefault();
                cleanVideoField();
              }}
            >
              <SvgIcon
                src="/img/new-icons/red-trash.svg"
                noFilterOnLight={true}
              />
            </button>
          )}
          <input
            className={`text-input file-input-other-form ${showDisableVideoInputClassUrl}`}
            type="file"
            name="videoFile"
            disabled={!!videoUrl}
            onChange={(e) => {
              if (e?.target?.files[0]?.size > fileLimit * 1024 * 1024) {
                setIsOutOfLimit(true);
                e.target.value = "";
                return;
              }
              setIsOutOfLimit(false);

              handleInputChange(e);
            }}
            form={form}
          />
        </label>
        {/* )} */}
      </div>
    </div>
  );
};

export default VideoUpload;
